export const customEmailSelectBoxStyle = {
  'maxHeight': '80px',
  'height': '80px',
  '& > div': {
    'alignItems': 'start',
    'overflowY': 'scroll',
    'paddingTop': '10px',
    'paddingBottom': '10px',
    '& > div': {
      'height': 'auto',
      'top': '17px',
      'alignItems': 'start',
      '& > input': {
        alignSelf: 'center',
      },
    },
  },
  '& > button': {
    display: 'none',
  },
};

export const emailManuStyle = {
  'display': 'block',
  '& > li': {
    '& > div:first-child': {
      display: 'none',
    },
  },
};
